import React, { useEffect, useState } from 'react';
import { Button, Card, Skeleton, Tag, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getContentItem } from '../../../services/content';
import { ContentItem } from '../../../types/content';
import { sanitizeAndNormalizeRichText } from '../../../utils/richText';

const ContentPreviewPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [row, setRow] = useState<ContentItem | null>(null);

  useEffect(() => {
    const load = async () => {
      const parsedId = Number(id);
      const validId = Number.isInteger(parsedId) && parsedId > 0;
      try {
        if (!validId) {
          message.error('内容ID无效');
          return;
        }
        setLoading(true);
        const data = await getContentItem(parsedId);
        setRow(data);
      } catch (error: any) {
        if (error?.response?.status === 404) {
          message.error('内容不存在或已被删除');
        } else {
          message.error('加载内容失败');
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">内容预览</h1>
          <p className="mt-1 text-gray-600">用于发布前检查内容样式与展示效果</p>
        </div>
        <Button onClick={() => navigate('/dashboard/admin/content/list')}>返回列表</Button>
      </div>

      {loading ? (
        <Skeleton active />
      ) : row ? (
        <Card>
          <div className="mb-3 flex items-center gap-2">
            <Tag>{row.channel_name}</Tag>
            <Tag color={row.status === 'published' ? 'green' : 'default'}>{row.status}</Tag>
          </div>
          <h2 className="text-2xl font-semibold text-gray-900">{row.title}</h2>
          {row.summary ? <p className="mt-3 text-gray-600">{row.summary}</p> : null}
          {row.image_url ? (
            <div className="mt-4">
              <img
                src={row.image_url}
                alt={row.title}
                className="max-h-[320px] w-full rounded-lg object-cover"
              />
            </div>
          ) : null}
          <div
            className="prose content-rich-text mt-6 max-w-none"
            dangerouslySetInnerHTML={{ __html: sanitizeAndNormalizeRichText(row.body || '') }}
          />
        </Card>
      ) : (
        <Card>未找到该内容</Card>
      )}
    </div>
  );
};

export default ContentPreviewPage;

